import type { ReactNode } from 'react'
import type { ClientPanelUser } from 'types'

import { useStore } from 'store'

type Props = {
  allowedFor: ClientPanelUser['type']
  children: ReactNode
}

const ProtectedRoute = ({ allowedFor, children }: Props) => {
  const { currentLoginUserClientPanel } = useStore()
  const auth = currentLoginUserClientPanel?.type === allowedFor

  return auth ? <>{children}</> : null
}

export default ProtectedRoute
